import BigNumber from "bignumber.js";
import TagInfo from "./tag";

export function parseEpc(code: string) {
    let result = '';
    for (let i = 0; i < code.length; i += 2) {
        let char = String.fromCharCode(parseInt(code.substring(i, i + 2), 16));
        if (char === '\0') {
            break;
        }
        result += char;
    }
    return result;
}

export function parseCode(code: string) {
    let result = '';
    for (let i = 0; i < code.length; i++) {
        result += code.charCodeAt(i).toString(16);
    }
    return result.toUpperCase() + (result.length % 4 ? '00' : '');
}

export function parseSku(code: string) {
    return new Promise<string>(resolve => {
        TagInfo.fromEpc(code, tag => {
            resolve(tag.sku);
        });
    });
}

export interface ModalRef<T> {
    show: (data: T) => void;
    hide: () => void;
}

export function willSendFile(e: React.DragEvent<HTMLElement>) {
    e.stopPropagation();
    e.preventDefault();
    e.dataTransfer.dropEffect = 'copy';
}

export function assertNumber(v: any): number {
    if (v instanceof BigNumber) {
        return v.toNumber();
    } else if (typeof v === 'object' || typeof v === 'undefined') {
        return 0;
    } else if (typeof v === 'boolean') {
        return v ? 1 : 0;
    } else if (typeof v === 'string') {
        return parseFloat(v);
    } else {
        return Number(v);
    }
}

export function assertRecord<T extends Record<any, any>>(v: any): T {
    if (typeof v === 'string') {
        return JSON.parse(v) as T;
    } else if (typeof v === 'object') {
        return v;
    } else {
        return {} as T;
    }
}
